import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar from '../EcoClub/Sidebar';
import EcoClub2026 from '../EcoClub2026';



const EcoClub1Class2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass1/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass1/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass1/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass1/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass1/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass1/6.webp`;


  const photos = [
    {
        src: p1,
        source: p1,
        rows: 1,
        cols: 1,
    },
    {
        src: p2,
        source: p2,
        rows: 1,
        cols: 1,
    },
    {
        src: p3,
        source: p3,
        rows: 1,
        cols: 1,
    },
    {
        src: p4,
        source: p4,
        rows: 1,
        cols: 1,
    },
    {
        src: p5,
        source: p5,
        rows: 1,
        cols: 1,
    },
    {
        src: p6,
        source: p6,
        rows: 1,
        cols: 1,
    }

  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
     World Environment Day  
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
      Class: 1  &  Date:  30 June 2026
        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
"A healthy planet and healthy people grow together. Protect nature, nourish your body, and build a brighter tomorrow."
        <br/>
        </Typography>
        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        Class 1 students celebrated World Environment Day through a series of engaging and meaningful activities that helped them understand the importance of caring for both the environment and their health.
The celebration began with a nature walk, during which students observed trees, plants, birds, flowers, and other elements of nature around the school campus. They discussed the importance of protecting the environment, keeping their surroundings clean, planting more trees, conserving water, and respecting all living things. The activity encouraged children to appreciate the beauty of nature and understand their role in preserving it. 
           
        <br></br>
         To reinforce the connection between a healthy environment and a healthy lifestyle, the celebration concluded with a Health and Wellness activity. Each student brought two fruits for their snack break and spoke about the fruits they had chosen, sharing their nutritional value, health benefits, and interesting facts. The discussion highlighted the importance of eating fresh, 
         natural foods and how fruits provide essential vitamins, minerals, and energy for healthy growth and development.
 <br></br>
        </Typography>
      </Box>
      

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <EcoClub2026   />
             </Box>
             <Box marginBottom={4}>
               <Sidebar />
             </Box>


    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default EcoClub1Class2026;